import { render } from "./LabeledSwitch.vue?vue&type=template&id=450a4d0a&scoped=true"
import script from "./LabeledSwitch.vue?vue&type=script&lang=js"
export * from "./LabeledSwitch.vue?vue&type=script&lang=js"

import "./LabeledSwitch.vue?vue&type=style&index=0&id=450a4d0a&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450a4d0a"]])

export default __exports__